import { apiClient } from 'api/apiClient';

const ITEMS = '/items';

export const getItemGroups = async (projectCode: string): Promise<string[]> => {
	const { data } = await apiClient.get(
		`${ITEMS}/groups/${encodeURIComponent(projectCode)}`
	);
	return data.groups;
};
